module.exports = __webpack_public_path__ + "static/assets/ac36bc9d0064fba29274a15ef29a1ae0.png";